import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const AgentGroupForm = ({ open, onClose, onSaved, group }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [nameError, setNameError] = useState('');
  const [loading, setLoading] = useState(false);

  const isEdit = Boolean(group);

  useEffect(() => {
    if (open) {
      setName(group?.name || '');
      setDescription(group?.description || '');
      setNameError('');
    }
  }, [open, group]);

  const handleSubmit = async () => {
    if (!name.trim()) {
      setNameError('El nombre es requerido');
      return;
    }
    setLoading(true);
    try {
      await onSaved({ name: name.trim(), description: description.trim(), group });
    } catch {
      // error handling delegated to parent
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        component="div"
        sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}
      >
        <Typography variant="h3" sx={{ py: 2 }}>
          {isEdit ? 'Editar grupo' : 'Crear grupo'}
        </Typography>
        <IconButton onClick={onClose} disabled={loading} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <TextField
          label="Nombre *"
          value={name}
          onChange={(e) => { setName(e.target.value); setNameError(''); }}
          error={Boolean(nameError)}
          helperText={nameError}
          fullWidth
          autoFocus
          sx={{ mb: 2, mt: 1 }}
        />
        <TextField
          label="Descripción"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          fullWidth
          multiline
          rows={2}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={loading}>
          {loading ? <CircularProgress size={20} /> : isEdit ? 'Guardar' : 'Crear'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
